class SelectorDirective
  @$inject: []
  constructor: ()->
    class Selector
      bindToController:
        selector: "="
      controller: ($scope, $element, $attrs)->
        track = $attrs.track
        @selectables = {}

        multi = $attrs.hasOwnProperty "multi"

        get = (selectable)=>
          return @selectables[selectable[track]];

        cache = (selectable)=>
          @selectables[selectable[track]] = selectable
          if @selector
            if multi
              @selector.forEach (selected, idx)=>
                if selected[track] is selectable[track]
                  @selector[idx] = selectable
            else
              if @selector[track] is selectable[track]
                @selector = selectable


        @register = (selectable)=>
          org = get(selectable)
          if org
            selectable.$selected = @selected(org)
          cache(selectable)

        @selectAll = (checked, selectables)=>
          for selectable in selectables
            org = get(selectable)
            if checked
              if not @selector
                @selector = []
              if(!@selector.filter((selector) ->  
                selector._id is selectable._id).length > 0) 
                @selector.push org
            else 
              if @selector
                idx = @selector.indexOf(org)
                if idx >= 0
                  @selector.splice(idx,1)            

        @select = (selectable)=>
          if not @selected(selectable)
            @check(selectable)
          else
            @uncheck(selectable)
          $scope.$apply()

        @selected = (selectable)=>
          org = get(selectable)
          return org?.$selected

        @check = (selectable)=>
          org = get(selectable)
          org.$selected = true
          if multi
            if not @selector
              @selector = []
            @selector.push org
          else
            if @selector
              @uncheck(@selector)
            @selector = org


        @uncheck = (selectable)=>
          org = get(selectable)
          if org
            org.$selected = false
            if multi
              idx = @selector.indexOf(org)
              @selector.splice(idx, 1)
            else
              @selector = null




        return @

    return new Selector()
module.exports = SelectorDirective


// WEBPACK FOOTER //
// ./src/common/selector/selector.coffee